<p-sidebar
    [(visible)]="sidebarVisible"
    class="document-sidebar"
    position="right"
    [modal]="true"
    (onHide)="onCloseSidebar()"
    [styleClass]="'w-30rem'"
>
    <ng-template pTemplate="content">
        <section class="sidebar-section" [attr.aria-labelledby]="header ? 'document-summary-sidebar-title' : null" [attr.aria-label]="!header ? 'Document summary' : null">
            <h2 *ngIf="header" id="document-summary-sidebar-title" class="mb-1">{{ header }}</h2>
            <h4 class="mb-3"> {{ documentName }} </h4>
            <div>{{summaryData}}</div>
        </section>
      </ng-template>
</p-sidebar>